const SEARCH_PREFIX = '@SEARCH_ALL';

export const FETCH = `${SEARCH_PREFIX}/FETCH`;
export const FETCH_SUCCESS = `${SEARCH_PREFIX}/FETCH_SUCCESS`;
export const FETCH_ERROR = `${SEARCH_PREFIX}/FETCH_ERROR`;

export const RESET_SERACH_DATA = `${SEARCH_PREFIX}/RESET_SERACH_DATA`;

export const LOAD_EXTRA_ITEMS = `${SEARCH_PREFIX}/LOAD_EXTRA_ITEMS`;
export const LOAD_EXTRA_ITEMS_SUCCESS = `${SEARCH_PREFIX}/LOAD_EXTRA_ITEMS_SUCCESS`;
export const LOAD_EXTRA_ITEMS_ERROR = `${SEARCH_PREFIX}/LOAD_EXTRA_ITEMS_ERROR`;
